import { useRef, useState } from "react";
import { api, fileSrc } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Upload, X, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function PhotoUploader({ value = [], onChange, label = "Photos", endpoint = "/upload", testid = "photo" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handleFiles = async (files) => {
    setBusy(true);
    const uploaded = [];
    for (const file of Array.from(files)) {
      try {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post(endpoint, fd, { headers: { "Content-Type": "multipart/form-data" } });
        uploaded.push({ url: data.url, path: data.path, filename: data.filename });
      } catch (e) {
        toast.error("Échec de l'envoi d'une photo");
      }
    }
    onChange([...(value || []), ...uploaded]);
    setBusy(false);
  };

  const remove = (idx) => onChange(value.filter((_, i) => i !== idx));

  return (
    <div className="space-y-2">
      {label && <div className="text-xs uppercase tracking-wider text-slate-500 font-medium">{label}</div>}
      <div className="flex flex-wrap gap-2">
        {(value || []).map((p, i) => (
          <div key={i} className="relative w-20 h-20 rounded-lg overflow-hidden border border-slate-200 group">
            <img src={fileSrc(p.url || p.path)} alt="" className="w-full h-full object-cover" />
            <button
              type="button"
              onClick={() => remove(i)}
              data-testid={`${testid}-remove-${i}`}
              className="absolute top-0.5 right-0.5 bg-black/70 rounded-full p-0.5 text-red-600 opacity-0 group-hover:opacity-100 transition"
            >
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
        ))}
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          data-testid={`${testid}-add`}
          className="w-20 h-20 rounded-lg border border-dashed border-slate-300 flex flex-col items-center justify-center gap-1 text-slate-500 hover:border-emerald-500/50 hover:text-emerald-600 transition"
        >
          {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <Upload className="w-5 h-5" />}
          <span className="text-[10px]">Ajouter</span>
        </button>
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/*,application/pdf"
        multiple
        className="hidden"
        onChange={(e) => e.target.files && handleFiles(e.target.files)}
      />
    </div>
  );
}
